import { Chip, Tooltip } from "@mui/material";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import type { TravelInfo } from "../api/types";

function formatMinutes(min: number): string {
    if (min < 60) return `${min} min`;
    const h = Math.floor(min / 60);
    const m = min % 60;
    return m ? `${h} h ${m} min` : `${h} h`;
}

interface Props {
    travel?: TravelInfo | null;
    /** "light" per sfondi colorati (card prossimo incontro) */
    tone?: "default" | "light";
}

/** Distanza e tempo in auto dalla nostra palestra (stima OpenStreetMap, senza traffico) */
export default function TravelChip({ travel, tone = "default" }: Props) {
    if (!travel) return null;
    const approx = travel.approximate ? "~" : "";
    const label = `${approx}${travel.km.toLocaleString("it-IT", { maximumFractionDigits: 1 })} km · ${approx}${formatMinutes(travel.minutes)} da Vellezzo`;
    const tooltip = "Stima in auto dalla nostra palestra (Impianti Sportivi, Vellezzo Bellini), senza traffico"
        + (travel.approximate ? ". Indirizzo non trovato: calcolata sul centro del comune" : "");

    return (
        <Tooltip title={tooltip}>
            <Chip
                size="small"
                icon={<DirectionsCarIcon />}
                label={label}
                color={tone === "light" ? undefined : "info"}
                variant={tone === "light" ? "filled" : "outlined"}
                sx={tone === "light"
                    ? { bgcolor: "rgba(255,255,255,0.22)", color: "white", fontWeight: 600, "& .MuiChip-icon": { color: "white" } }
                    : { fontWeight: 600, alignSelf: "flex-start" }}
            />
        </Tooltip>
    );
}
